import { useState, useEffect } from 'react';

/**
 * Hook for detecting device type and Telegram WebApp environment.
 * Helps in providing responsive UI for mobile/desktop consolidation.
 */
export const useDevice = () => {
    const [isTelegram, setIsTelegram] = useState(!!window.Telegram?.WebApp?.initData);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            const isTg = !!window.Telegram?.WebApp?.initData;
            const isSmall = window.innerWidth <= 768;
            setIsTelegram(isTg);
            setIsMobile(isTg || isSmall);
        };

        checkDevice();
        window.addEventListener('resize', checkDevice);
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    return {
        isMobile,
        isTelegram,
        isDesktop: !isMobile
    };
};
